import { Label } from './common/label'
import { useForm } from './form'

export const FormSimpleSelectBool = ({ name, label, required, hidden, readonly }) => {
  const { register } = useForm(name, { required, valueAsBool: true, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <select className={`form-control ${readonly && 'bg-secondary-subtle'}`} {...register()} readOnly={readonly}>
        <option value={''}>Select</option>
        <option value={true}>True</option>
        <option value={false}>False</option>
      </select>
    </Label>
  )
}
